import eight from '../assets/svg/projects/eight.svg'
import seven from '../assets/svg/projects/seven.svg'
import six from '../assets/svg/projects/six.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Ayla Networks',
        projectDesc: 'This project about Simplifying the Development of Smart Home & IoT Solutions.',
        tags: ['React', 'SAAS', 'React Bootstrap'],
        code: '',
        demo: 'https://www.aylanetworks.com/',
        image: six
    },
    {
        id: 2,
        projectName: 'Jewelry Niche',
        projectDesc: 'This project is a Jewelry shop, Customer can be buy product and manage them and make payment.',
        tags: ['React', 'Express', 'Material Ui'],
        
        demo: 'https://pandora-web.netlify.app/',
        image: seven
    },
    {
        id: 3,
        projectName: 'Travel Agency',
        projectDesc: 'This project about travel agency management.',
        tags: ['React', 'CSS', 'Material Ui'],
        code: 'https://github.com/Travel-Agency-client',
        demo: 'https://travel-agency-fc58b.web.app/',
        image: eight
    }
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/